import { Link } from '@optimus-web/core';
import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { EnterpriseLink } from '@mews-commander/ui';
import { WithAccountId } from '@mews-commander/types';
import { usePaymentsTablesContext } from '../../tables/PaymentsTablesContext';
import { WithPaymentPlanId } from '../../tables/PaymentPlans/types';

interface Props extends WithPaymentPlanId, WithAccountId {
    linkContent: string;
}

export const PaymentPlanDetailsLink = ({ paymentPlanId, accountId, linkContent }: Props) => {
    const { openPaymentPlansDetails } = usePaymentsTablesContext();
    const isPaymentPlanDetailPageEnabled = useFeatureFlag(FeatureFlag.paymentPlanDetailPageEnabled);

    return isPaymentPlanDetailPageEnabled ? (
        <EnterpriseLink
            variant="basic"
            to="Payment/Plans/$accountId/Detail/$paymentPlanId"
            params={{ paymentPlanId, accountId }}
        >
            {linkContent}
        </EnterpriseLink>
    ) : (
        <Link onClick={() => openPaymentPlansDetails(paymentPlanId)} inherit>
            {linkContent}
        </Link>
    );
};
